/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
    root: {
        overflowX: 'hidden',
        boxSizing: 'border-box',
        width: '100%',
        paddingBottom: '10px'
    },
    card: {
        borderRadius: '8px',
        boxShadow: tokens.shadow2,
        gap: '6px',
        paddingInline: '16px',
        position: 'relative'
    },
    title: {
        fontSize: '14px',
        fontWeight: '700',
        marginBottom: '8px',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
});